export default function(data, element, skipBinding) {
  const self = this;
  self.$el = $(element);
  self.saving = ko.observable(false);

  self.bindData = function(data) {
    self.forum_thread = ko.mapping.fromJS(data.forum_thread);
  };

  self.save = function() {
    const data = ko.mapping.toJS(self.forum_thread);
    const request = new Kadenze.AjaxRequest({
      type: self.forum_thread.type(),
      url: self.forum_thread.url(),
      data: { 'forum_thread': data },
      dataAsJson: false
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: data.message });
      window.location.href = data.forum_thread_path
    });

    request.fail(function(xhr, status, error) {
      new Kadenze.Notice.error({message: data.message });
    });
  };

  const __construct = function() {
    if (!skipBinding) {
      data = JSON.parse(data);
      self.bindData(data);
    }
  }(this);
  return self;
}
